import React from 'react'

const PrincipalsMessage = () => {
  return (
    <>
     

    </>
  )
}

export default PrincipalsMessage